<!--Popover Starts-->
<section id="popovers">
  <div class="row text-left">
    <div class="col-sm-12">
      <div class="content-header">Popovers</div>
    </div>
  </div>
  <div class="row text-left" matchHeight="card">
    <!--Quick and easy popovers Starts-->
    <div class="col-md-12 col-lg-6">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Quick and easy popovers</h4>
        </div>
        <div class="card-content">
          <div class="card-body">
            <button type="button" class="btn btn-outline-primary mr-1 mb-1" placement="right"
              ngbPopover="Vivamus sagittis lacus vel augue laoreet rutrum faucibus." popoverTitle="Popover on right">
              Popover on right
            </button>

            <button type="button" class="btn btn-outline-danger mr-1 mb-1" placement="top"
              ngbPopover="Vivamus sagittis lacus vel augue laoreet rutrum faucibus." popoverTitle="Popover on top">
              Popover on top
            </button>

            <button type="button" class="btn btn-outline-info mr-1 mb-1" placement="left"
              ngbPopover="Vivamus sagittis lacus vel augue laoreet rutrum faucibus." popoverTitle="Popover on left">
              Popover on left
            </button>

            <button type="button" class="btn btn-outline-warning mr-1 mb-1" placement="bottom"
              ngbPopover="Vivamus sagittis lacus vel augue laoreet rutrum faucibus." popoverTitle="Popover on bottom">
              Popover on bottom
            </button>
          </div>
        </div>
      </div>
    </div>
    <!--Quick and easy popovers Ends-->

    <!--HTML and bindings in popovers Starts-->
    <div class="col-md-12 col-lg-6">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">HTML and bindings in popovers</h4>
          <p>Popovers can contain any arbitrary HTML, Angular bindings and even directives! Simply enclose desired
            content in
            a <code>&lt;template&gt;</code> element.</p>
        </div>
        <div class="card-content">
          <div class="card-body">
            <ng-template #popContent>Hello, <b>{{name}}</b>!</ng-template>
            <ng-template #popTitle>Fancy <b>content!!</b></ng-template>
            <button type="button" class="btn btn-outline-success" [ngbPopover]="popContent" [popoverTitle]="popTitle">
              I've got markup and bindings in my popover!
            </button>
          </div>
        </div>
      </div>
    </div>
    <!--HTML and bindings in popovers Ends-->
  </div>
  <div class="row text-left" matchHeight="card">
    <!--Custom and manual triggers Starts-->
    <div class="col-md-12 col-lg-6">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Custom and manual triggers</h4>
          <p>You can easily override open and close triggers by specifying event names (separated by <code>:</code>) in
            the
            <code>triggers</code> property.</p>
        </div>
        <div class="card-content">
          <div class="card-body">
            <button type="button" class="btn btn-outline-primary" ngbPopover="You see, I show up on hover!"
              triggers="mouseenter:mouseleave" popoverTitle="Pop title">
              Hover over me!
            </button>
            <p class="pt-3">
              Alternatively you can take full manual control over popover opening / closing events.
            </p>
            <button type="button" class="btn btn-outline-info mr-1" ngbPopover="What a great tip!" triggers="manual"
              #p="ngbPopover" (click)="p.open()" popoverTitle="Pop title">
              Click me to open a popover
            </button>
            <button type="button" class="btn btn-outline-warning" (click)="p.close()">
              Click me to close a popover
            </button>
          </div>
        </div>
      </div>
    </div>
    <!--Custom and manual triggers Ends-->

    <!--Append popover in the body Starts-->
    <div class="col-md-12 col-lg-6">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Append popover in the body</h4>
          <p> Set the <code>container</code> property to "body" to have the popover be appended to the body instead of
            the triggering
            element's parent. This option is useful if the element triggering the popover is inside an element that
            clips
            its contents (i.e. <code>overflow: hidden</code>).</p>
        </div>
        <div class="card-content">
          <div class="card-body">
            <div class="mb-0" style="padding: 20px 0; text-align: center; overflow:hidden">
              <button type="button" class="btn btn-outline-success btn-sm mr-1"
                ngbPopover="Vivamus sagittis lacus vel augue laoreet rutrum faucibus." container="body">
                Popover appended to body
              </button>
              <button type="button" class="btn btn-outline-danger btn-sm"
                ngbPopover="Vivamus sagittis lacus vel augue laoreet rutrum faucibus.">
                Default popover
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--Append popover in the body Ends-->
  </div>
  <div class="row text-left" matchHeight="card">
    <!--Context and manual triggers Starts-->
    <div class="col-md-12 col-lg-6">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Context and manual triggers</h4>
          <p> You can optionally pass in a context when manually triggering a popover.</p>
        </div>
        <div class="card-content">
          <div class="card-body">
            <ng-template #popContent1 let-greeting="greeting">{{greeting}}, <b>{{name}}</b>!</ng-template>
            <ng-template #popTitle1 let-language="language">Greeting in {{language}}</ng-template>
            <button type="button" class="btn btn-outline-warning mr-1" [ngbPopover]="popContent1"
              [popoverTitle]="popTitle1" triggers="manual" #p1="ngbPopover"
              (click)="toggleWithGreeting(p1, 'Bonjour', 'French')">
              French
            </button>
            <button type="button" class="btn btn-outline-info mr-1" [ngbPopover]="popContent1"
              [popoverTitle]="popTitle1" triggers="manual" #p2="ngbPopover"
              (click)="toggleWithGreeting(p2, 'Gutentag', 'German')">
              German
            </button>
            <button type="button" class="btn btn-outline-danger mr-1" [ngbPopover]="popContent1"
              [popoverTitle]="popTitle1" triggers="manual" #p3="ngbPopover"
              (click)="toggleWithGreeting(p3, 'Hello', 'English')">
              English
            </button>
          </div>
        </div>
      </div>
    </div>
    <!--Context and manual triggers Ends-->

    <!--Popover visibility events Starts-->
    <div class="col-md-12 col-lg-6">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Popover visibility events</h4>
        </div>
        <div class="card-content">
          <div class="card-body">
            <button type="button" class="btn btn-outline-primary" placement="top"
              ngbPopover="Vivamus sagittis lacus vel augue laoreet rutrum faucibus." popoverTitle="Popover on top"
              #popover="ngbPopover">
              Open Popover
            </button>

            <p class="pt-3">
              Popover is currently: <code>{{ popover.isOpen() ? 'open' : 'closed' }}</code>
            </p>
          </div>
        </div>
      </div>
    </div>
    <!--Popover visibility events Ends-->
  </div>
</section>
<!--Popover Starts-->
